export default __webpack_public_path__ + "static/media/profile-avatar.25f1ea94.jpg";